import { render, staticRenderFns } from "./ImageManage.vue?vue&type=template&id=ca1b940a&scoped=true"
import script from "./ImageManage.vue?vue&type=script&lang=js"
export * from "./ImageManage.vue?vue&type=script&lang=js"
import style0 from "./ImageManage.vue?vue&type=style&index=0&id=ca1b940a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1b940a",
  null
  
)

export default component.exports